export const DEFAULT_DEBOUNCE_DELAY = 500;
export const types = {
  INVOICES: 'invoice',
  PAYMENTS: 'payment',
  CREDIT_NOTE: 'creditnote',
};
